
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/property-sheet",
      function () {
        return require("private-next-pages/property-sheet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/property-sheet"])
      });
    }
  